document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 990) return;

  document.querySelectorAll('header-menu').forEach((menu) => {
    const details = menu.querySelector('details');
    if (!details) return;

    let timer;

    menu.addEventListener('mouseenter', () => {
      clearTimeout(timer);
      details.setAttribute('open', '');
    });

    menu.addEventListener('mouseleave', () => {
      timer = setTimeout(() => {
        details.removeAttribute('open');
      }, 250);
    });

    const submenu = menu.querySelector('.header__submenu');

    if (submenu) {
      submenu.addEventListener('mouseenter', () => {
        clearTimeout(timer);
      });

      submenu.addEventListener('mouseleave', () => {
        timer = setTimeout(() => {
          details.removeAttribute('open');
        }, 250);
      });
    }
  });
});